import { InputTextArea, Row, Select, useForm } from '@/components/forms'
import { workerRegistry } from '@/lib/agents/registry'
import { AllAIModels, OpenAIModels } from '@/lib/agents/modellist'
import { createModel } from '@/lib/data/model'
import { NodeProps } from '@xyflow/react'
import { ScanEye } from "lucide-react"
import { InlineHandles, WorkerLabeledHandle } from '../handles'
import { useWorker } from '../hooks'
import { MemoizedWorker } from '../memoizedworkers'
import { NodeLayout } from './node'

const { vision } = workerRegistry

vision.icon = ScanEye

const model = createModel({
  fields: {
    prompt: { title: "Prompt", type: "string" },
    model: { title: "Model", type: "string", list: OpenAIModels },
  }
})

function Parameters({ worker }: { worker: VisionWorker }) {

  const { form, m, watch } = useForm(model, {
    values: {
      prompt: worker.parameters.prompt,
      model: worker.parameters.model,
    }
  })

  watch((value, { name }) => {
    if (name === "prompt") worker.parameters.prompt = value.prompt
    if (name === "model") worker.parameters.model = value.model
  })

  return <form.context>
    <div className='px-2 nodrag w-full grow flex flex-col'>
      <Row className='grow'>
        <InputTextArea field={m.prompt} span={12} hideLabel className='min-h-10 h-full resize-none' />
      </Row>
      <Row className='py-2'>
        <Select field={m.model} span={12} />
      </Row>
    </div>
  </form.context>

}

export function VisionNode(props: NodeProps) {
  const worker = useWorker<VisionWorker>(props.id)

  return <NodeLayout worker={worker} resizable minHeight={300} className='flex flex-col'>
    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.input} />
      <WorkerLabeledHandle handler={worker.fields.output} />
    </InlineHandles>
    <MemoizedWorker worker={worker} name="parameters">
      <Parameters worker={worker} />
    </MemoizedWorker>
  </NodeLayout>
}
